import { render, staticRenderFns } from "./SearchResultsContact.vue?vue&type=template&id=50f23b78&scoped=true&"
import script from "./SearchResultsContact.vue?vue&type=script&lang=js&"
export * from "./SearchResultsContact.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsContact.vue?vue&type=style&index=0&id=50f23b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f23b78",
  null
  
)

export default component.exports